import MessageBanner from './MessageBanner';

export default MessageBanner;



// WEBPACK FOOTER //
// ./src/components/atoms/MessageBanner/index.js